import { Box } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

export const ScrollableList: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        maxHeight: '300px',
        overflowY: 'overlay',
        '&::-webkit-scrollbar': {
          display: 'none'
        }
      }}
    >
      {children}
    </Box>
  );
};
